import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import NotFound from "./components/NotFound";
import { locations } from "./seo/routes";
import "./App.css";
import "./semantic-subset.css";
import Contact from "./components/Contact";

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/services" element={<Services />} />
    <Route path="/services/:category" element={<Services />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/gallery" element={<Gallery />} />
    {locations.map((location) => (
      <Route
        key={location.slug}
        path={`/${location.slug}`}
        element={<Location location={location} />}
      />
    ))}
    {/* <Route path="/book-online" element={<OnlineBooking />} /> */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => {
  return (
    <Router>
      <Header />
      <AppRoutes />
      <Footer />
    </Router>
  );
};

export default App;
